let Settings = {
	firstRun: false,
	sound: true,
	icon: true,
	typing: true,
	mention: false,
	messagesStyle: 'compact',
	notifyAll: false,
	confirmPageClose: true,
	statusMessages: true,
	statusMessageNotifications: true,
	lastState: {
		rooms: [],
	},
};

Settings.__proto__ = {
	save() {
		localStorage.chatSettings = JSON.stringify(this);
	},

	load() {
		this.mention = this.isNotificationPermissionGranted();

		if ('chatSettings' in localStorage){
			let obj = JSON.parse(localStorage.chatSettings);
			if (obj){
				for (let k in obj){
					this[k] = obj[k];
				}
			}
		}

		this.mention = this.mention && this.isNotificationPermissionGranted();
	},

	isNotificationPermissionGranted() {
		return 'Notification' in window && Notification.permission == 'granted';
	},
};

Settings.load();

export default Settings;
